import { all, fork } from 'redux-saga/effects';
import ndfl3Reducer from '../components/NDFL3/NDFL3Actions';
import ndfl2DetailsReducer from './2ndfl-details/reducer';
import ndfl2DetailsSaga from './2ndfl-details/saga';
import { ndfl3CopyReducer, ndfl3DataReducer, ndfl3ReSendReducer } from './3ndfl-view/reducers';
import { ndfl3CopySaga, ndfl3DataSaga, ndfl3ReSendSaga } from './3ndfl-view/saga';
import {
  ndfl3XMLDraftReducer,
  ndfl3XMLSubmitDeclarationReducer,
  ndfl3XMLValidationReducer,
  ndfl3XMLYearsReducer,
} from './3ndfl-xml/reducers';
import {
  ndfl3XMLGetDraftSaga,
  ndfl3XmlSaga,
  ndfl3XMLSubmitSaga,
  ndfl3XMLValidateSaga,
  ndfl3XMLYearsSaga,
} from './3ndfl-xml/saga';

import appealCategoriesReducer from './appealCategories/reducer';
import appealCategoriesSaga from './appealCategories/saga';
import appealThemesReducer from './appealThemes/reducer';
import appealThemesSaga from './appealThemes/saga';
import attachmentsReducer from './attachments/reducer';
import cardDocumentTypesReducer from './cardDocumentTypes/reducer';
import cardDocumentTypesSaga from './cardDocumentTypes/saga';
import certificateInfoReducer from './certificate/reducer';
import certificateInfoSaga from './certificate/saga';
import countriesListReducer from './countries/reducer';
import countriesListSaga from './countries/saga';
import declarationAvailableYearSaga from './availableYears/saga';

import currencyListReducer from './currencyList/reducer';
import currencyListSaga from './currencyList/saga';
import documentTypesReducer from './documentTypes/reducer';
import documentTypesSaga from './documentTypes/saga';
import incomeTypesReducer from './incomeTypes/reducer';
import incomeTypesSaga from './incomeTypes/saga';
import movementReportData from './movementReportData/reducer';
import movementReportDataSaga from './movementReportData/saga';
import movementReportList from './movementReportList/reducer';
import movementReportListSaga from './movementReportList/saga';
import parentTaxAuthorityReducer from './parentTaxAuthority/reducer';
import parentTaxAuthoritySaga from './parentTaxAuthority/saga';
import regionsReducer from './regions/reducer';
import regionsSaga from './regions/saga';
import responseDataReducer from './responseData/reducer';
import skvpzuListReducer from './skvpzuCodes/reducer';
import skvpzuListSaga from './skvpzuCodes/saga';
import sntsListReducer from './sntsCodes/reducer';
import sntsListSaga from './sntsCodes/saga';
import snuReducer from './snu/reducer';
import snuSaga from './snu/saga';
import snusReducer from './snus/reducer';
import snusSaga from './snus/saga';
import taxAuthoritiesReducer from './taxAuthorities/reducer';
import taxAuthoritiesSaga from './taxAuthorities/saga';
import taxObjectReducer from './taxObject/reducer';
import taxpayerCategoriesReducer from './taxpayerCategories/reducer';
import taxpayerCategoriesSaga from './taxpayerCategories/saga';
import refusalPdfReducer from './refusalPdf/reducer';
import refusalPdfSaga from './refusalPdf/saga';
import typesOfLandUse from './typesOfLandUse/reducer';
import typesOfLandUseSaga from './typesOfLandUse/saga';
import parsedFiasReducer from './fiasAdress/reducer';
import parsedFiasSaga from './fiasAdress/saga';
import situationsReducer from './situations/reducer';
import situationsSaga from './situations/saga';
import topSituationsReducer from './topSituations/reducer';
import topSituationsSaga from './topSituations/saga';
import detail3NDFLFundsReducer from './detail3NDFLFunds/reducer';
import detail3NDFLFundsSaga from './detail3NDFLFunds/saga';
import accountSignListReducer from './acountSign/reducer';
import accountSignListSaga from './acountSign/saga';
import sentToGp3Reducer from './sentToGp3/reducer';
import sentToGp3Saga from '../components/SendToGP3/sagas';
import declarationAvailableYearReducer from './availableYears/reducer';
import ndfl3LightReducer from 'modules/Taps/components/NDFL3Light/redux/reducer';

import fileCategoriesListReducer from './fileCategories/reducer';
import getFileCategoriesListSaga from './fileCategories/saga';
import informParticipationReducer from 'modules/Taps/components/Situations/components/InformParticipation/redux/redux';
import informParticipationSaga from 'modules/Taps/components/Situations/components/InformParticipation/redux/sagas';
import { NDFL3LightSaga } from 'modules/Taps/components/NDFL3Light/sagas';
import { NDFL3LightCharityDeductionsSaga } from 'modules/Taps/components/NDFL3LightCharity/sagas';
import { NDFL3LightIISDeductionsSaga } from 'modules/Taps/components/NDFL3LightIIS/sagas';
import { NDFL3LightHealingDeductionsSaga } from 'modules/Taps/components/NDFL3LightHealing/sagas';
import { NDFL3LightEducationDeductionsSaga } from 'modules/Taps/components/NDFL3LightEducation/sagas';
import { NDFL3LightRentalIncomeSaga } from 'modules/Taps/components/NDFL3LightRentalIncome/sagas';
import { NDFL3LightPropertyDeductionsSaga } from 'modules/Taps/components/NDFL3LightProperty/sagas';
import { NDFL3LightPropertyIncomeSaga } from 'modules/Taps/components/NDFL3LightPropertyIncome/sagas';
import ndfl3LightPropertyIncomeReducer from 'modules/Taps/components/NDFL3LightPropertyIncome/redux/reducer';
import { getNDFL3Sagas } from './ndfl3Saga/NDFL3SagaMain';
import { qualifiedSignatureApplicationSaga } from 'modules/Taps/components/QualifiedSignatureApplication/sagas/mainSaga';
import { requestForSearchPaymentSaga } from 'modules/Taps/components/RequestForSearchPayment/sagas/mainSaga';
import { objectDestructionSaga } from 'modules/Taps/components/ObjectDestruction/sagas/mainSaga';
import ObjectDestructionReducer from 'modules/Taps/components/ObjectDestruction/redux/reducer';
import { transportDestructionSaga } from 'modules/Taps/components/TransportDestruction/sagas/mainSaga';
import TransportDestructionReducer from 'modules/Taps/components/TransportDestruction/redux/reducer';
import QSApplicationReducer from 'modules/Taps/components/QualifiedSignatureApplication/redux/reducer';
import SearchPaymentReducer from 'modules/Taps/components/RequestForSearchPayment/redux/reducer';
import okvedReducer from 'modules/Taps/redux/okveds/reducer';
import okvedsSaga from 'modules/Taps/redux/okveds/saga';
import SimplifiedDeductionsReducer from 'modules/Taps/components/SimplifiedDeductions/redux/reducer';
import { simplifiedDeductionsSaga } from 'modules/Taps/components/SimplifiedDeductions/sagas/mainSaga';

export const tapsReducers = {
  responseData: responseDataReducer,
  certificateInfo: certificateInfoReducer,
  countries: countriesListReducer,
  sntsList: sntsListReducer,
  skvpzuList: skvpzuListReducer,
  taxObject: taxObjectReducer,
  snu: snuReducer,
  snus: snusReducer,
  documentTypes: documentTypesReducer,
  attachments: attachmentsReducer,
  regions: regionsReducer,
  regionTaxAuthorities: taxAuthoritiesReducer,
  appealCategories: appealCategoriesReducer,
  appealThemes: appealThemesReducer,
  taxpayerCategories: taxpayerCategoriesReducer,
  parentTaxAuthority: parentTaxAuthorityReducer,
  incomeTypes: incomeTypesReducer,
  ndfl2Details: ndfl2DetailsReducer,
  ndfl3: ndfl3Reducer,
  cardDocumentTypes: cardDocumentTypesReducer,
  ndfl3XMLdraft: ndfl3XMLDraftReducer,
  ndfl3XMLYears: ndfl3XMLYearsReducer,
  ndfl3XMLValidation: ndfl3XMLValidationReducer,
  ndfl3XMLSubmitDeclaration: ndfl3XMLSubmitDeclarationReducer,
  currencyList: currencyListReducer,
  ndfl3Data: ndfl3DataReducer,
  ndfl3Copy: ndfl3CopyReducer,
  ndfl3ReSend: ndfl3ReSendReducer,
  movementReportList,
  movementReportData,
  refusalPdf: refusalPdfReducer,
  landUseTypes: typesOfLandUse,
  fiasAddress: parsedFiasReducer,
  filteredSituations: situationsReducer,
  topSituations: topSituationsReducer,
  detailsReturnFunds: detail3NDFLFundsReducer,
  accountSignList: accountSignListReducer,
  sentToGp3Status: sentToGp3Reducer,
  fileCategoriesList: fileCategoriesListReducer,
  ndfl3Light: ndfl3LightReducer,
  ndfl3LightPropertyObjects: ndfl3LightPropertyIncomeReducer,
  availableYears: declarationAvailableYearReducer,
  informParticipation: informParticipationReducer,
  qsApplication: QSApplicationReducer,
  searchPayment: SearchPaymentReducer,
  simplifiedDeductions: SimplifiedDeductionsReducer,
  objectDestruction: ObjectDestructionReducer,
  okveds: okvedReducer,
  transportDestruction: TransportDestructionReducer,
};

export function* tapsSagas() {
  yield all(
    [
      certificateInfoSaga,
      countriesListSaga,
      sntsListSaga,
      skvpzuListSaga,
      snuSaga,
      snusSaga,
      documentTypesSaga,
      regionsSaga,
      taxAuthoritiesSaga,
      appealCategoriesSaga,
      appealThemesSaga,
      taxpayerCategoriesSaga,
      parentTaxAuthoritySaga,
      incomeTypesSaga,
      ndfl2DetailsSaga,
      cardDocumentTypesSaga,
      ndfl3XmlSaga,
      ndfl3XMLYearsSaga,
      ndfl3XMLValidateSaga,
      ndfl3XMLSubmitSaga,
      ndfl3XMLGetDraftSaga,
      currencyListSaga,
      getNDFL3Sagas,
      ndfl3DataSaga,
      ndfl3CopySaga,
      ndfl3ReSendSaga,
      movementReportListSaga,
      movementReportDataSaga,
      refusalPdfSaga,
      typesOfLandUseSaga,
      parsedFiasSaga,
      situationsSaga,
      topSituationsSaga,
      detail3NDFLFundsSaga,
      accountSignListSaga,
      sentToGp3Saga,
      getFileCategoriesListSaga,
      NDFL3LightSaga,
      NDFL3LightCharityDeductionsSaga,
      NDFL3LightIISDeductionsSaga,
      NDFL3LightHealingDeductionsSaga,
      NDFL3LightEducationDeductionsSaga,
      NDFL3LightRentalIncomeSaga,
      NDFL3LightPropertyDeductionsSaga,
      NDFL3LightPropertyIncomeSaga,
      declarationAvailableYearSaga,
      informParticipationSaga,
      qualifiedSignatureApplicationSaga,
      requestForSearchPaymentSaga,
      objectDestructionSaga,
      okvedsSaga,
      simplifiedDeductionsSaga,
      transportDestructionSaga,
    ].map(function (saga) {
      return fork(saga);
    }),
  );
}
